import { render, staticRenderFns } from "./WarehouseAndInventories.vue?vue&type=template&id=226d1fa8&"
import script from "./WarehouseAndInventories.vue?vue&type=script&lang=js&"
export * from "./WarehouseAndInventories.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseAndInventories.vue?vue&type=style&index=0&id=226d1fa8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports